import { getOT, type ExceptionEvent } from './getOT';

/**
 * Key is the exception code + message.
 */
type Stats = Record<string, number>;

/**
 * Collects stats on OT exceptions.s
 */
export class OtExceptionsStats {
  private stats: Stats = {};
  private exceptionHandler: ((event: ExceptionEvent) => void) | null = null;

  async collect(): Promise<void> {
    const OT = await getOT();
    this.stats = {};

    // Unsubscribe to avoid double subscription
    if (this.exceptionHandler) {
      OT.off('exception', this.exceptionHandler);
    }

    this.exceptionHandler = (event: ExceptionEvent) => {
      const statsEvent = `${event.code}:${event.message}`;
      this.stats[statsEvent] = (this.stats[statsEvent] ?? 0) + 1;
    };

    OT.on('exception', this.exceptionHandler);
  }

  finalizeAndGetStats(): Stats {
    // Unsubscribe from events
    if (this.exceptionHandler) {
      const handlerToRemove = this.exceptionHandler;
      getOT()
        .then((OT) => {
          OT.off('exception', handlerToRemove);
          return null;
        })
        .catch((err) => {
          console.error('Error unsubscribing from OT exceptions:', err);
        });
      this.exceptionHandler = null;
    }

    // Return final stats
    return this.stats;
  }
}

export const otExceptionsStats = new OtExceptionsStats();
